export function escapeClassSelector(selector: string) {
  return selector.replace(/([!"#$%&'()*+,/:;<=>?@[\\\]^`{|}~])/g, "\\$1");
}
